"use strict";const r=require("./index8.js"),t=require("./index192.js");var a=r._export,e=t.isArray;a({target:"Array",stat:!0},{isArray:e});
